import React from "react";
import {
  FormControl,
  MenuItem,
  InputLabel,
  Select as MuiSelect,
  FormHelperText,
} from "@mui/material";
import { Field } from "react-final-form";

const Select = (props) => {
  const {
    name,
    label,
    variant,
    data,
    dataKey,
    dataValue,
    initialValue,
    ...restSelectProps
  } = props;
  // console.log("restSelectProps", restSelectProps);
  // console.log("props", props);
  return (
    <Field
      name={name}
      label={label}
      required={true}
      initialValue={initialValue}
      render={({ input, meta, value, onChange, label, ...restInput }) => {
        return (
          <FormControl style={{ minWidth: "100%" }} variant={variant}>
            <InputLabel htmlFor={input.name} variant="standard" shrink={true}>
              {label}
            </InputLabel>
            <MuiSelect {...input} {...restSelectProps}>
              <MenuItem />
              {data.map((item) => (
                <MenuItem key={item[dataKey]} value={item[dataKey]}>
                  {item[dataValue]}
                </MenuItem>
              ))}
            </MuiSelect>
            {meta.error && meta.touched && (
              <FormHelperText>{meta.error || meta.submitError}</FormHelperText>
            )}
          </FormControl>
        );
      }}
    />
  );
};

export default Select;
